import gql from 'graphql-tag'
import { useChannelId } from 'src/hooks'
import { useQuery } from 'react-apollo'

const query = gql`
  query channelLabguardVersion($channelId: ID!) {
    channel(id: $channelId) {
      id
      acqChain {
        id
        sensor {
          id
          revision
        }
      }
    }
  }
`

/**
 * Given a `channel` prop, renders nothing if it uses a sensor matching the given revision.
 * @param revision A device revision (LG2, LG3...)
 */
export default function DontRenderForRevision({ revision, children }) {
  // retrieve current channel
  const { data: { channel: { acqChain } = {} } = {} } = useQuery(query, {
    variables: { channelId: useChannelId() },
  })

  // render nothing if the channel uses a sensor matching the given revision
  return acqChain && acqChain.sensor && acqChain.sensor.revision !== revision ? children : ''
}
